export const DEFAULT_NAV_TIMEOUT = 1; // 1 second
